<template>
  <div v-if="body_show" class="body">
    <img src="@a/spell_top.png" alt="" class="spell_img" />
    <div class="spell_top">
      <div class="course clearfix">
        <img :src="data.bigcoursepromotionimg" alt="" />
        <div class="course_fg">
          <h3>{{data.bigcoursename}}</h3>
          <h4 v-if="data.coursename">课程期次：{{data.coursename}}</h4>
          <h4 v-if="data.course_begintime">开课时间：{{data.course_begintime}}</h4>
        </div>
      </div>
      <div class="mevs clearfix" v-if="data.courselist">
        <h2>选择期次</h2>
        <van-radio-group class="radio_group" :class="item.selected?'radio_group_over':''" v-for="(item,index) in data.courselist" :key="index" v-model="cid" :disabled="item.selected">
          <van-radio :name="item.id">
            {{item.sign_endtime}} 开课
          </van-radio>
        </van-radio-group>
      </div>
      <h2>拼团价格  <span class="spe">￥{{data.price}}<b>￥{{originalprice}}</b></span></h2>
      <h2 v-if="data.deadline">拼团规则  <span>开团后<b>{{data.deadline}}小时自动结束</b>/{{data.num}}人团</span></h2>
      <h2 v-if="countdown">拼团规则  <span><b>{{time}} 后自动结束</b>/{{data.num}}人团</span></h2>
    </div>
    <div class="spell_top" v-if="data.joinlist && data.joinlist.length>0">
      <h2>参团成员</h2>
      <ul class="clearfix">
        <li v-for="(item,index) in data.joinlist" :key="index" v-if="item.is_leader" class="clearfix fl">
          <div class="img">
            <img :src="item.headimgurl" alt="" />
            <span>团长</span>
          </div>
          <div class="time">
            <h3>{{item.nickname}}</h3>
            <h4>{{item.create_time}} 发起</h4>
          </div>
        </li>
        <li v-for="(item,index) in data.joinlist" :key="index" v-if="!item.is_leader">
          <img :src="item.headimgurl" alt="" />
        </li>
      </ul>
    </div>
    <div class="spell_top">
      <h2>拼团须知</h2>
      <p>{{data.notice}}</p>
    </div>
    <div class="foot" @click="payHandle" v-if="scrabble_type=='create'">
      发起拼团 ￥{{data.price}}
    </div>
    <div class="foot foot1" v-else-if="scrabble_type=='join'">
      <div class="foot_l" @click="card_show=true">
        邀请好友参团
      </div>
      <div class="foot_r" @click="payHandle">
        我要参团
      </div>
    </div>
    <div class="foot" v-else-if="scrabble_type=='invite'" @click="card_show=true">
      邀请好友参团
    </div>
    <div class="pop_img" v-show="card_show" @click="card_show=false"></div>
    <public-mobile ref="handle" @refiers="pullData" :scrabble="scrabble"></public-mobile>
    <van-popup v-model="complete_show">
      <div class="complete">
        <h2>您好，此团已成团</h2>
        <h3>{{time_s}}秒后调转课程详情页可发起拼团</h3>
        <router-link :to="'/course_details?bid=' + data.bid">发起拼团</router-link>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  createScrabble,
  joinScrabble,
  inviteScrabble
} from "@/api/course"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        cid: '',
        scrabble_id: '',
        data: {},
        body_show: false,
        originalprice: '',
        countdown: 0,
        time: '',
        scrabble: {},
        scrabble_type: "",
        card_show: false,
        type_obj: {},
        complete_show: true,
        time_s: 3
      }
    },
    watch: {
      radio(curVal, oldVal) {
        // 修改课程期数
        for (let arg of this.data.list) {
          if (arg.id == curVal) {
            this.originalprice = arg.originalprice;
          }
        };
      }
    },
    methods: {
      // 支付
      payHandle() {
        this.scrabble = {
          cid: this.cid,
          scrabble_id: this.scrabble_id
        }
        setTimeout(() => {
          this.$refs.handle.pay_spell()
        }, 300)

      },
      // 当前时间的格式化字符串
      timeTostring() {
        if (this.countdown > 0) {
          this.sin = setInterval(() => {
            var secondTime = parseInt(this.countdown); // 秒
            var minuteTime = 0; // 分
            var hourTime = 0; // 小时
            var dayTime = 0; // 天
            if (secondTime > 60) { //如果秒数大于60，将秒数转换成整数
              //获取分钟，除以60取整数，得到整数分钟
              minuteTime = parseInt(secondTime / 60);
              //获取秒数，秒数取佘，得到整数秒数
              secondTime = parseInt(secondTime % 60);
              //如果分钟大于60，将分钟转换成小时
              if (minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取佘的分，获取分钟除以60取佘的分
                minuteTime = parseInt(minuteTime % 60);
                if (hourTime > 24) {
                  //获取天，获取小时除以24，得到整数天
                  dayTime = parseInt(hourTime / 24);
                  //获取天后取佘的小时，获取小时除以24取佘的小时
                  hourTime = parseInt(hourTime % 24);
                }
              }
            }
            var result = ((secondTime < 10) ? "0" : "") + parseInt(secondTime);

            if (minuteTime > 0) {
              result = ((minuteTime < 10) ? "0" : "") + parseInt(minuteTime) + ": " + result;
            }
            if (hourTime > 0) {
              result = ((hourTime < 10) ? "0" : "") + parseInt(hourTime) + ": " + result;
            }
            if (dayTime > 0) {
              result = ((dayTime < 10) ? "0" : "") + parseInt(dayTime) + ": " + result;
            }

            this.time = result;
            this.countdown -= 1;
          }, 1000);
        } else {
          clearInterval(this.sin)
        }
      },
      pullData() {
        this.$toast({
          type: 'loading',
          mask: true,
          message: '加载中...'
        });
        let query = this.$route.query;
        this.scrabble_id = query.scrabble_id ? query.scrabble_id : '';
        this.scrabble_type = query.scrabble_type;
        let Scrabble = '';
        if (query.scrabble_type == 'create') {
          Scrabble = createScrabble;
          document.title = '开团';
        } else if (query.scrabble_type == 'join') {
          Scrabble = joinScrabble;
          document.title = '参团';
        } else if (query.scrabble_type == 'invite') {
          Scrabble = inviteScrabble;
          document.title = '邀请好友参团';
        }
        Scrabble({
            bid: query.bid ? query.bid : '',
            scrabble_id: query.scrabble_id ? query.scrabble_id : ''
          })
          .then((data) => {
            this.$toast.clear();
            if (data.code == 10002) {
              this.$toast(data.data.msg);
              return
            }
            if (data.link) {
              this.$router.push({
                path: '/course_spell',
                query: {
                  scrabble_type: 'invite',
                  scrabble_id: query.scrabble_id
                }
              });
              return
            }

            this.body_show = true;
            this.data = data.data;
            // this.complete_show = this.data.complete_show;
            if (this.complete_show) {
              let sin = setInterval(() => {
                if (this.time_s > 0) {
                  this.time_s -= 1;
                } else {
                  clearInterval(sin);
                  this.$router.push({
                    path: '/course_details',
                    query: {
                      bid: this.data.bid
                    }
                  });
                }
              }, 1000);
            }
            if (query.scrabble_type == 'invite') {
              this.data = data;
              this.countdown = this.data.countdown ? this.data.countdown : 0;
              this.timeTostring()
            }

            if (this.data.courselist && this.data.courselist.length > 0) {
              this.cid = this.data.courselist[0].id;
              this.originalprice = this.data.courselist[0].originalprice;
            }

            this.type_obj = {
              scrabble_type: query.scrabble_type,
              scrabble_id: query.scrabble_id,
              surplus: this.data.surplus,
              bigcoursename: this.data.bigcoursename,
              bid: this.data.bid,
            };
            shareCon("spell", this, this.type_obj);
          })
      }
    },
    created() {
      this.pullData(this.pulldata);
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.body {
  padding: 0 30px;
  padding-bottom: 110px;
}

img.spell_img {
  width: 100%;
}

.spell_top {
  width: 100%;
  padding: 30px 20px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  margin-top: 20px;
  h2 {
    color: #333;
    font-size: 28px;
    font-weight: bold;
    margin-top: 30px;
    span {
      font-size: 26px;
      color: #333;
      b {
        color: #EB5032;
        font-weight: normal;
      }
    }
    .spe {
      font-size: 36px;
      color: #EB5032;
      b {
        font-weight: normal;
        color: #999;
        font-size: 26px;
        text-decoration: line-through;
      }
    }
  }
  p {
    border-top: 1px solid rgba(204, 204, 204, 1);
    padding-top: 30px;
    line-height: 40px;
    font-size: 26px;
    color: #666;
    margin-top: 20px;
  }
  .course {
    display: block;
    position: relative;
    border-bottom: 2px solid #ccc;
    padding-bottom: 30px;
    .course_fg {
      float: left;
      margin-left: 20px;
      h3 {
        color: #333;
        font-size: 28px;
        font-weight: bold;
      }
      h4 {
        color: #999;
        font-size: 24px;
        margin-top: 0;
      }
    }
    img {
      width: 200px;
      float: left;
    }
    span.sp1 {
      color: #333;
      font-size: 26px;
      float: right;
    }
  }
  ul {
    margin-top: 30px;
    border-top: 1px solid rgba(204, 204, 204, 1);
    padding-top: 30px;
    li {
      float: right;
      margin-left: -20px;
      width: 100px;
      height: 100px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .fl {
      float: left;
      width: auto;
      margin-left: 0;
      .img {
        width: 100px;
        height: 100px;
        float: left;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        span {
          display: inline-block;
          width: 66px;
          height: 30px;
          background: linear-gradient(90deg, rgba(235, 80, 50, 1), rgba(245, 127, 23, 1));
          border-radius: 15px;
          line-height: 30px;
          color: #fff;
          font-size: 20px;
          position: absolute;
          bottom: 0;
          left: 17px;
          text-align: center;
        }
      }
      .time {
        margin-left: 22px;
        float: left;
        margin-top: 10px;
        h3 {
          font-size: 26px;
          color: #333;
          width: 174px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        h4 {
          margin-top: 10px;
          font-size: 24px;
          color: #999;
        }
      }
    }
  }
}

.foot {
  background: #EB5032;
  width: 100%;
  max-width: 750px;
  line-height: 98px;
  height: 98px;
  position: fixed;
  left: 50%;
  margin-left: -375px;
  bottom: 0;
  text-align: center;
  z-index: 2;
  font-size: 34px;
  color: #fff;
  .foot_l {
    width: 214px;
    display: inline-block;
    background: #fff;
    color: #EB5032;
    font-size: 28px;
  }
  .foot_r {
    width: 536px;
    display: inline-block;
    background: #EB5032;
    color: #fff;
  }
}

.foot1 {
  background: none
}

.pop_img {
  width: 100%;
  height: 100%;
  z-index: 100001;
  position: fixed;
  top: 0;
  left: 0;
  background: url(../../../assets/popse.png) no-repeat top center;
  background-size: cover;
}

.complete {
  width: 480px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  text-align: center;
  padding-top: 50px;
  h2 {
    font-size: 34px;
    color: #333;
  }
  h3 {
    font-size: 26px;
    color: #666;
    margin-top: 10px;
  }
  a {
    line-height: 100px;
    width: 100%;
    border-top: 1px solid #ccc;
    font-size: 34px;
    color: #EB5032;
    display: block;
    margin-top: 48px;
  }
}
</style>
<style>
.mevs {
  margin-top: 0
}

.mevs .radio_group {
  margin-top: 30px;
  width: 300px;
  line-height: 70px;
  text-align: center;
  color: #EB5032;
  font-size: 26px;
  border: 2px solid rgba(235, 80, 50, 1);
  float: left;
  position: relative;
}

.mevs .radio_group:nth-child(odd) {
  float: right;
}

.mevs .radio_group_over {
  color: #999999;
  border-color: #ccc
}

.mevs .radio_group:last-child {
  margin-bottom: 0;
}

.mevs .radio_group .van-radio {
  /* width: 100%;
  position: relative;*/
}

.mevs .radio_group .van-radio .van-radio__icon {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 36px;
  line-height: 36px;
}

.mevs .radio_group .van-radio .van-radio__icon .van-icon {
  border: none;
  background: none;
}

.mevs .radio_group .van-radio .van-radio__icon .van-icon:before {
  content: '';
}

.radio_group .van-radio .van-radio__icon.van-radio__icon--checked .van-icon.van-icon-success {
  width: 43px;
  height: 36px;
  background-image: url(../../../assets/radio_dw.png);
  background-size: cover;
  border-radius: 0;
  transition: .03s;
}

.mevs .radio_group .van-radio__label {
  line-height: 100%;
  text-align: center;
  color: #EB5032;
  margin-left: 0;
  font-size: 26px;
}

.mevs .radio_group_over .van-radio__label {
  color: #999
}
</style>
